import api from '../../../shared/services/api';

const automacoesService = {
  listar: () => api.get('/automacoes'),
  obter: (id) => api.get(`/automacoes/${id}`),
  criar: (data) => api.post('/automacoes', data),
  atualizar: (id, data) => api.put(`/automacoes/${id}`, data),
  atualizarStatus: (id, status) => api.put(`/automacoes/${id}/status`, { status }),
  excluir: (id) => api.delete(`/automacoes/${id}`),
  duplicar: (id) => api.post(`/automacoes/${id}/duplicar`),
  stats: (id) => api.get(`/automacoes/${id}/stats`),
  leads: (id, params) => api.get(`/automacoes/${id}/leads`, { params }),
  logs: (id, params) => api.get(`/automacoes/${id}/logs`, { params }),
  diagnostico: (id) => api.get(`/automacoes/${id}/diagnostico`),
  capaStats:   (id) => api.get(`/automacoes/${id}/capa-stats`),
  listarTags: () => api.get('/tags'),
  // rapido=1: lista do banco, sem checar status no provider (instantâneo)
  listarSessoes: () => api.get('/whatsapp/sessoes', { params: { rapido: 1 } }),
};

export default automacoesService;
